import { GlobalConfig, makeAddressSync } from "@silo/types";
import { MARKET_ADDRESS } from "./market-address";

export const GLOBAL_CONFIG: GlobalConfig = {
  revenue: {
    protocolKey: "arbitrum",
    marketAddress: MARKET_ADDRESS.arbitrum.SILO,
    siloIncentivesControllerAddress: makeAddressSync(
      "0xB03A9C6b6eBDe80BC358c1bF8694f41B4f83Bb9D"
    ),
    targetTokenAddress: makeAddressSync(
      "0x0341c0c0ec423328621788d4854119b97f44e391"
    ),
    targetTokenSymbol: "SILO",
    targetTokenDecimals: 18,
    shareTokenAddress: makeAddressSync(
      "0x7d353420B3Eb3Cd9e7C819b4fEA369686fd26b32"
    ),
    shareTokenType: "protected",
    rewardTokenAddress: makeAddressSync(
      "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1"
    ),
    rewardTokenSymbol: "ETH",
    rewardTokenDecimals: 18,
  },
};
